/* eslint-disable */
// Assets //
import greyMapPin from "../../assets/grey_pin.svg";
import { ReactComponent as ClearIcon } from "../../assets/wrong.svg";
import { ReactComponent as BackIcon } from "../../assets/back.svg";
import BarLoader from "react-spinners/BarLoader";
import { Important } from "..";
import { useState, useEffect, useRef, useCallback, useReducer } from "react";
import axiosInstance from "../../config/apiInterceptor.config";
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import axios from "axios";
import { MagnifyingGlass } from "../../components/icons/MagnifyingGlass";
import { ButtonSearch } from "../buttons/buttonSearch.component";
import {
  SEARCH_ACTIONS,
  initialState,
  searchReducer,
} from "../../reducers/search.reducer";

const MAPBOXTOKEN = process.env.REACT_APP_MAPBOXTOKEN;
const COMPARABLES_URI = process.env.REACT_APP_COMPARABLES_URI;

console.log(COMPARABLES_URI);

const UDASearch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // for using context
  // const { selectAsset, selectedOption } = useCalculatorContext();
  const [state, dispatch] = useReducer(searchReducer, initialState);
  const previousController = useRef(); // for axios request cancellation
  const searchParams = new URLSearchParams(location.search);
  const inputRef = useRef(null);
  const iframeKey = searchParams.get("key");
  const qaTesting = searchParams.get("qa_testing");

  // Visual states
  const [isLoading, setIsLoading] = useState(false);
  const [isFilteredResultsVisible, setIsFilteredResultsVisible] =
    useState(false);
  const [isPortalsVisible, setIsPortalsVisible] = useState(false);
  const [isCadastralExactMatchVisible, setCadastralExactMatchVisible] =
    useState(false);
  const [isCadastralRefValidVisible, setIsCadastralRefValidVisible] =
    useState();
  const [isCadastralSuggestionsVisible, setIsCadastralSuggestionsVisible] =
    useState(false);
  const [showClearButton, setShowClearButton] = useState(false);
  const [isAddressWrongFormatError, setIsAddressWrongFormatError] =
    useState(false);
  const [noHousesFound, setNoHousesFound] = useState(false);
  const [noPortalsFound, setNoPortalsFound] = useState(false);

  // Search data
  const [inputValue, setInputValue] = useState("");
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [passedThroughPortals, setPassedThroughPortals] = useState(false);
  const [portals, setPortals] = useState([]);
  const [isRecommendedNumbersVisible, setIsRecommendedNumbersVisible] =
    useState(false);

  // Get cadastral data by providing an address
  const getCadastralData = async (address) => {
    await axiosInstance
      .get(
        `${COMPARABLES_URI}cadastral?address=${encodeURIComponent(
          address
        )}&typology_type=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${iframeKey}`,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 400) {
          dispatch({
            type: SEARCH_ACTIONS.NO_PORTALS_FOUND,
            payload: { noPortalsFound: true },
          });
        } else if (
          response.data.code === 200 &&
          response.data.type === "exact"
        ) {
          const results = Object.values(response.data.results).flat();
          const filteredResults = results.filter(
            (obj) => obj.listing_type === 1
          );
          if (filteredResults.length === 0) {
            setNoHousesFound(true);
          } else {
            dispatch({
              type: SEARCH_ACTIONS.UPDATE_FILTERED_RESULTS,
              payload: { filteredResults: filteredResults },
            });
          }
        } else if (
          response.data.code === 200 &&
          response.data.type === "portals"
        ) {
          setPassedThroughPortals(true);
          dispatch({
            type: SEARCH_ACTIONS.UPDATE_PORTALS,
            payload: { portals: response.data.results },
          });
        } else if (
          response.data.code === 200 &&
          response.data.type === "recommended"
        ) {
          dispatch({
            type: SEARCH_ACTIONS.UPDATE_RECOMMENDED,
            payload: {
              recommendedNumbers: response.data.results.map((portal) =>
                portal.replace(/\s/g, "")
              ),
            },
          });
        }
        setIsLoading(false);
      });
    return;
  };

  // Get cadastral portals by providing a portal id
  const getCadastralDataByPortalID = async (portalID) => {
    setIsLoading(true);
    await axiosInstance
      .get(
        `${COMPARABLES_URI}cadastral-by-portal-id?id_address_portal=${decodeURIComponent(
          portalID
        )}&typology_type=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${iframeKey}`,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 400) {
          dispatch({
            type: SEARCH_ACTIONS.NO_PORTALS_FOUND,
            payload: { noPortalsFound: true },
          });
          setNoPortalsFound(true);
        } else if (
          response.data.code === 200 &&
          response.data.type === "exact"
        ) {
          if (response.data.results.hasOwnProperty("1")) {
            const results = response.data.results["1"];
            dispatch({
              type: SEARCH_ACTIONS.UPDATE_FILTERED_RESULTS,
              payload: { filteredResults: results },
            });
          } else {
            dispatch({
              type: SEARCH_ACTIONS.NO_HOUSES_FOUND,
              payload: { noHousesFound: true },
            });
          }
        }
      });
    setIsLoading(false);
    return;
  };

  // Get an asset information by providing a cadastral reference
  const getAssetData = async (cadastralRef) => {
    setIsLoading(true);
    const upperCased = cadastralRef.toString().toUpperCase();
    const result = await axiosInstance
      .get(`${COMPARABLES_URI}get-cadastral?cadastral_ref=${upperCased}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${iframeKey}`,
        },
      })
      .then((response) => {
        if (response.status === 204) {
          setIsCadastralRefValidVisible(true);
          setIsLoading(false);
          return;
        } else if (response.status === 200) {
          console.log(response.data.property_type);
          const result = {
            address: response.data.address,
            door: response.data.door,
            block: response.data.block,
            staircase: response.data.staircase,
            portal: response.data.portal,
            lat: response.data.location.coordinates[1]
              ? response.data.location.coordinates[1]
              : null,
            lon: response.data.location.coordinates[0]
              ? response.data.location.coordinates[0]
              : null,
            area: response.data.cadastral_area,
            floor: response.data.floor,
            rooms: response.data.rooms,
            nbaths: response.data.nbaths,
            has_garage: response.data.has_garage,
            has_pool: response.data.has_pool,
            has_air_conditioner: response.data.has_air_conditioner
              ? response.data.has_air_conditioner
              : null,
            // property_type: parsePropertyType(response.data.property_type),
            property_type: response.data.property_type,
            cadastral_bi: response.data.cadastral_reference,
            boundary_id: response.data.admin5_id,
            postal_code: response.data.postal_code,
            municipio: response.data.admin3_name,
            provincia: response.data.admin2_name,
          };
          console.log(result.property_type);
          dispatch({
            type: SEARCH_ACTIONS.UPDATE_CADASTRAL_EXACT_MATCH,
            payload: { cadastralExactMatch: [result] },
          });
          setIsLoading(false);
          return result;
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
    setIsCadastralRefValidVisible(false);
    setIsLoading(false);
    return result;
  };

  const handleSearch = useCallback(
    _.debounce(async (query, signal, requestId) => {
      await axiosInstance
        .get(
          `${COMPARABLES_URI}suggest-cadastral?address=${encodeURIComponent(
            query
          )}&typology_type=1`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${iframeKey}`,
            },
            signal: signal,
          }
        )
        .then(function (response) {
          if (response.data.code === 200) {
            dispatch({
              type: SEARCH_ACTIONS.UPDATE_CADASTRAL_SUGGESTIONS,
              payload: { cadastralSuggestions: response.data.results },
            });
            dispatch({
              type: SEARCH_ACTIONS.UPDATE_SUGGESTION_CALL_QUERY,
              payload: { suggestionCallQuery: response.data.results },
            });
          }
          setIsLoading(false);
        })
        .catch(function (e) {
          if (axios.isCancel(e)) {
            console.error("aborted request");
          } else {
            setIsLoading(false);
          }
        });
    }, 400),
    []
  );

  const handleInputChange = (input) => {
    dispatch({ type: SEARCH_ACTIONS.CLEAR_ALL_BUT_SUGGESTIONS });
    setInputValue(input);
    if (input.length === 0) {
      dispatch({
        type: SEARCH_ACTIONS.UPDATE_CADASTRAL_SUGGESTIONS,
        payload: { cadastralSuggestions: [] },
      });
      setIsAddressWrongFormatError(false);
      setShowClearButton(false);
      return;
    } else {
      setShowClearButton(true);
    }
    if (input.trim() !== "" && _.isEmpty(state.cadastralSuggestions)) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
      if (previousController.current) {
        // setTimeout(() => {
        //   previousController.current.abort();
        // }, 1000);
      }
    }
    // Cancelling requests
    const controller = new AbortController();
    const signal = controller.signal;
    previousController.current = controller;

    if (input.trim() !== "" && input.length >= 14 && /^\S*$/.test(input)) {
      const trimmedValue = input.replace(" ", "");
      getAssetData(trimmedValue);
    } else {
      handleSearch(input, signal);
    }
  };

  // Cleans up search states whenever the input changes
  const handleResetInput = () => {
    dispatch({ type: SEARCH_ACTIONS.CLEAR_ALL });
    setInputValue("");
    setIsLoading(false);
  };

  // handle API call to get data of the chosen suggestion
  const handleRetrieve = (res, coords, postCode) => {
    // setInputValue(res); TODO: poner el input con la calle pero asi se triggerean las suggestions
    setIsLoading(true);
    dispatch({
      type: SEARCH_ACTIONS.UPDATE_CADASTRAL_SUGGESTIONS,
      payload: { cadastralSuggestions: [] },
    });
    dispatch({
      type: SEARCH_ACTIONS.UPDATE_FILTERED_RESULTS,
      payload: { filteredResults: [] },
    });
    dispatch({
      type: SEARCH_ACTIONS.UPDATE_COORDS,
      payload: { coords: coords },
    });
    dispatch({
      type: SEARCH_ACTIONS.UPDATE_POSTAL_CODE,
      payload: { postalCode: postCode },
    });
    dispatch({
      type: SEARCH_ACTIONS.UPDATE_SELECTED_ADDRESS,
      payload: { selectedAddress: res },
    });
    getCadastralData(res);
    setIsLoading(false);
  };

  const handleSelectPortal = (portal, portalId) => {
    dispatch({
      type: SEARCH_ACTIONS.UPDATE_SELECTED_PORTAL,
      payload: { selectedPortal: portal },
    });
    getCadastralDataByPortalID(portalId);
  };

  const handleNextStep = async (result) => {
    setIsLoading(true);
    if (result === null) {
      const assetData = {
        address: state.selectedAddress,
        lat: state.coords[1],
        lon: state.coords[0],
        postal_code: state.postalCode,
      };
      const assetProfileData = new URLSearchParams(assetData);
      console.log(assetProfileData);

      navigate(`/active?key=${iframeKey}&${assetProfileData}`, {
        replace: true,
      });
      return window.location.reload();
    } else {
      const assetData = await getAssetData(
        result.cadastral_ref || result.cadastral_bi
      );
      const assetProfileData = new URLSearchParams(assetData);
      navigate(
        `/active?key=${iframeKey}&${assetProfileData}${
          qaTesting ? "&qa_testing=true" : ""
        }`,
        { replace: true }
      );
      return window.location.reload();
    }
  };

  const handleBackPortalsNumber = () => {
    dispatch({
      type: SEARCH_ACTIONS.UPDATE_SELECTED_PORTAL,
      payload: { selectedPortal: "" },
    });
    dispatch({
      type: SEARCH_ACTIONS.UPDATE_CADASTRAL_SUGGESTIONS,
      payload: { cadastralSuggestions: [] },
    });
    dispatch({
      type: SEARCH_ACTIONS.UPDATE_FILTERED_RESULTS,
      payload: { filteredResults: [] },
    });
    dispatch({
      type: SEARCH_ACTIONS.UPDATE_CADASTRAL_EXACT_MATCH,
      payload: { cadastralExactMatch: [] },
    });
    dispatch({
      type: SEARCH_ACTIONS.NO_HOUSES_FOUND,
      payload: { noHousesFound: false },
    });
    setNoPortalsFound(false);
    setIsPortalsVisible(true);
  };

  const handleSelectOption = (asset) => {
    dispatch({ type: SEARCH_ACTIONS.CLEAR_ALL });
    dispatch({
      type: SEARCH_ACTIONS.SELECT_OPTION,
      payload: { selectedOption: asset },
    });
  };

  useEffect(() => {
    dispatch({
      type: SEARCH_ACTIONS.IFRAME_KEY,
      payload: { iframeKey: iframeKey },
    });
  }, [dispatch, iframeKey]);

  // useEffect(() => {
  //   console.log("key stored: ", state.iframeKey);
  // }, [state.iframeKey])

  useEffect(() => {
    if (!_.isEmpty(state.portals) && passedThroughPortals) {
      setIsPortalsVisible(true);
    } else {
      setIsPortalsVisible(false);
    }
  }, [state.portals]);

  useEffect(() => {
    if (state.selectedPortal.length !== 0) {
      setIsPortalsVisible(false);
    }
  }, [state.selectedPortal]);

  useEffect(() => {
    if (!_.isEmpty(state.recommendedNumbers)) {
      setIsRecommendedNumbersVisible(true);
    } else {
      setIsRecommendedNumbersVisible(false);
    }
  }, [state.recommendedNumbers]);

  useEffect(() => {
    if (!_.isEmpty(state.cadastralExactMatch)) {
      setCadastralExactMatchVisible(true);
    } else {
      setCadastralExactMatchVisible(false);
    }
  }, [state.cadastralExactMatch]);

  useEffect(() => {
    if (!_.isEmpty(state.filteredResults)) {
      setIsFilteredResultsVisible(true);
    } else {
      setIsFilteredResultsVisible(false);
    }
  }, [state.filteredResults]);

  useEffect(() => {
    if (!_.isEmpty(state.cadastralSuggestions)) {
      setIsCadastralSuggestionsVisible(true);
    } else {
      setIsCadastralSuggestionsVisible(false);
    }
  }, [state.cadastralSuggestions]);

  // state log
  // useEffect(() => {
  //   console.log("updated state: ", state);
  // }, [state])

  return (
    <>
      {iframeKey ? (
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className=" bg-[#FAFBFC] w-full bg-opacity-60 tablet:p-8 p-4 rounded-xl tablet:space-y-0 space-y-4"
        >
          <div className="space-y-4">
            <div className="flex tablet:flex-row flex-col bg-white p-2 rounded-xl">
              <div className="relative items-center w-full">
                <input
                  id="mapbox-autofill"
                  ref={inputRef}
                  name="address"
                  value={inputValue}
                  onChange={(e) => handleInputChange(e.target.value)}
                  type="text"
                  autoComplete="shipping street-address"
                  placeholder={"Dirección del inmueble o referencia catastral"}
                  className="w-full p-3 pl-10 pr-12 text-[#212632] placeholder-[#747D93] font-roboto rounded-xl"
                />
                {showClearButton && (
                  <div
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={() => {
                      handleResetInput();
                      setShowClearButton(false);
                    }}
                  >
                    <ClearIcon fill="#747D93" />
                  </div>
                )}
                <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                  <MagnifyingGlass fill="#747D93" />
                </div>
              </div>
              {/* ButtonSearchNOMobile */}
              <div className="tablet:block hidden">
                <ButtonSearch
                  onClick={() => handleNextStep(state.selectedOption)}
                  data={"rounded-full py-[10px] h-full"}
                  disabled={!_.isEmpty(state.selectedOption) ? false : true}
                />
              </div>
            </div>
          </div>
          <div
            style={{ overflow: "hidden", margin: 0 }}
            className="search-interactive-container"
          >
            {isLoading && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BarLoader
                  color={"#262626"}
                  loading={isLoading}
                  cssOverride={{ width: "90%" }}
                  size={100}
                  aria-label="Loading spinner"
                />
              </div>
            )}
            {((!_.isEmpty(state.filteredResults) && isFilteredResultsVisible) ||
              isCadastralExactMatchVisible) && (
              <ul className="flex flex-col max-h-[250px] bg-white mt-2 p-4 rounded-lg space-y-2 overflow-y-auto search-interactive-container">
                <p className="text-[#363C4B] font-semibold">
                  {state.selectedPortal.length !== 0 &&
                    !isCadastralExactMatchVisible && (
                      <button
                        className="text-[#363C4B] font-semibold"
                        type="button"
                        onClick={() => handleBackPortalsNumber()}
                      >
                        <div className="flex items-center">
                          <BackIcon className="mr-2" />
                          Volver a los portales
                        </div>
                      </button>
                    )}
                </p>
                {!isPortalsVisible && isFilteredResultsVisible && (
                  <div className="flex-row">
                    <p className="flex flex-row flex-wrap text-[#363C4B] font-semibold">
                      Selecciona la vivienda que quieres valorar{"\u00A0"}
                      {state.selectedPortal ? `en\u00A0` : ""}
                      {state.selectedPortal && (
                        <p style={{ color: "#DE0E48" }}>
                          Portal {state.selectedPortal}
                        </p>
                      )}
                    </p>
                  </div>
                )}
                {isCadastralExactMatchVisible && (
                  <div className="flex-row">
                    <p className="flex flex-row flex-wrap text-[#363C4B] font-semibold">
                      Referencia catastral en{" "}
                      {state.cadastralExactMatch &&
                        console.log(state.cadastralExactMatch)}
                    </p>
                  </div>
                )}
                {isFilteredResultsVisible &&
                  state.filteredResults.map((result, index) => {
                    return (
                      <div>
                        <li
                          key={index}
                          onClick={() => {
                            handleSelectOption(result);
                            const floor = result.floor ? result.floor : "";
                            setInputValue(
                              result.address +
                                ", Planta " +
                                floor +
                                ", " +
                                result.area +
                                "m²"
                            );
                          }}
                          className="flex flex-col w-full flex-wrap search-portal-item"
                        >
                          <button className="flex w-full" type="button">
                            <div className="flex flex-wrap w-full gap-2 items-center justify-between rounded-xl overflow-hidden">
                              <div className="flex flex-wrap flex-row gap-1 items-center">
                                <p
                                  style={{
                                    display: "flex",
                                    alignContent: "center",
                                  }}
                                >
                                  Planta {result.floor}
                                </p>
                                <p className="text-gray-300">|</p>
                                {result.door && (
                                  <p
                                    style={{
                                      display: "flex",
                                      alignContent: "center",
                                    }}
                                  >
                                    Puerta {result.door}{" "}
                                    {result.block && result.block}
                                  </p>
                                )}
                                <p className="text-gray-300">|</p>
                                {result.staircase && (
                                  <>
                                    <p
                                      style={{
                                        display: "flex",
                                        alignContent: "center",
                                      }}
                                    >
                                      Escalera {result.staircase}
                                    </p>
                                    <p className="text-gray-300">|</p>
                                  </>
                                )}
                                <p
                                  style={{
                                    display: "flex",
                                    alignContent: "center",
                                  }}
                                >
                                  {result.area} m²
                                </p>
                              </div>
                              <p
                                style={{
                                  display: "flex",
                                  alignContent: "center",
                                }}
                              >
                                {result.cadastral_bi || result.cadastral_ref}
                              </p>
                            </div>
                          </button>
                        </li>
                        <div className="result-separator"></div>
                      </div>
                    );
                  })}
                {isCadastralExactMatchVisible &&
                  state.cadastralExactMatch.map((result, index) => {
                    return (
                      <li
                        key={index}
                        onClick={() => {
                          handleSelectOption(result);
                          const floor = result.floor ? result.floor : "";
                          setInputValue(
                            result.address +
                              ", Planta " +
                              floor +
                              ", " +
                              result.area +
                              "m²"
                          );
                        }}
                        className="flex flex-col w-full search-portal-item"
                      >
                        <button className="w-full" type="button">
                          <span className="flex flex-wrap w-full items-center justify-between rounded-xl">
                            <span className="flex space-x-2">
                              <p>Planta {result.floor}</p>
                              <p className="text-gray-300">|</p>
                              <p>Puerta {result.door}</p>
                              <p className="text-gray-300">|</p>
                              <p>{result.area} m²</p>
                            </span>
                            <p>{result.cadastral_bi}</p>
                          </span>
                        </button>
                      </li>
                    );
                  })}
              </ul>
            )}
            {/* No ha hecho match con catastro pero te recomienda números cercanos*/}
            {isRecommendedNumbersVisible && (
              <div className="bg-white p-4 rounded-lg mt-1 space-y-4 mt-2 search-interactive-container">
                <p className="text-[#363C4B] font-semibold">
                  Busca por localización o ref. catastral
                </p>
                <div className="flex tablet:flex-row flex-col items-center border border-[#1778FB] bg-[#EFF7FB] rounded-md p-4 tablet:space-x-4">
                  <Important className="h-10 w-10" />
                  <span className="text-[#1778FB] w-10/12">
                    <p>
                      Los números más cercanos son{" "}
                      {Object.values(state.recommendedNumbers).join(", ")}.
                    </p>
                    <p>Edita tu búsqueda o ve a la localización.</p>
                  </span>
                  <button
                    onClick={() => handleNextStep(null)}
                    className="text-[#1778FB] font-bold tablet:whitespace-nowrap whitespace-normal"
                  >
                    Ir a la localización
                  </button>
                </div>
              </div>
            )}
            {/* El usuario no ha buscado por número y se le muestran los números o portales disponibles en la calle buscada*/}
            {isPortalsVisible && (
              <div className="flex flex-col max-h-[250px] bg-white p-4 rounded-lg mt-2 search-interactive-container">
                <p className="text-[#363C4B] font-semibold">
                  Portales en {state.selectedAddress}
                </p>
                <ul className="flex flex-row flex-wrap max-h-[220px] bg-white p-3 rounded-lg gap-2 overflow-y-auto">
                  {state.portals.map((result, index) => {
                    return (
                      <li
                        key={index}
                        onClick={() => {
                          handleSelectPortal(result.portal, result.id_portal);
                        }}
                        className="search-portal-item"
                      >
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {result.portal}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            {/* No se ha encontrado ningún número para la calle buscada */}
            {state.noPortalsFound && (
              <div className="bg-white p-4 rounded-lg mt-1 space-y-4 search-interactive-container">
                <div className="flex tablet:flex-row flex-col items-center border border-[#1778FB] bg-[#EFF7FB] rounded-md p-4 tablet:space-x-4">
                  <Important className="h-10 w-10" />
                  <p className="text-[#1778FB] w-10/12">
                    No hay coincidencias con catastro, pero te podemos llevar a
                    la localización.
                  </p>
                  <button
                    onClick={() => handleNextStep(null)}
                    className="text-[#1778FB] font-bold tablet:whitespace-nowrap whitespace-normal"
                  >
                    Ir a la localización
                  </button>
                </div>
              </div>
            )}
            {/* No se han encontrado casas para el portal seleccionado */}
            {state.noHousesFound && (
              <div className="bg-white p-4 rounded-lg mt-1 space-y-4 search-interactive-container">
                <p className="text-[#363C4B] font-semibold">
                  {(isFilteredResultsVisible || noHousesFound) &&
                    !isPortalsVisible &&
                    state.portals.length > 0 && (
                      <button
                        className="text-[#363C4B] font-semibold"
                        type="button"
                        onClick={() => handleBackPortalsNumber()}
                      >
                        <div className="flex items-center">
                          <BackIcon className="mr-2" />
                          Volver a los portales
                        </div>
                      </button>
                    )}
                </p>
                <div className="flex tablet:flex-row flex-col items-center border border-[#1778FB] bg-[#EFF7FB] rounded-md p-4 tablet:space-x-4">
                  <Important className="h-10 w-10" />
                  <p className="text-[#1778FB] w-10/12">
                    No hemos encontrado viviendas en el número seleccionado.
                    Intenta probar con otro número, buscar por referencia
                    catastral o ir a la localización.
                  </p>
                  <button
                    onClick={() => handleNextStep(null)}
                    className="text-[#1778FB] tablet:whitespace-nowrap whitespace-normal p-3"
                  >
                    <strong>Ir a la localización</strong>
                  </button>
                </div>
              </div>
            )}
            {/* Suggestions de mapbox */}
            {isCadastralSuggestionsVisible && (
              <ul className="flex flex-col max-h-[250px] bg-white p-4 rounded-lg mt-1 space-y-2 overflow-y-auto search-interactive-container">
                {state.cadastralSuggestions.map((result, index) => {
                  return (
                    <li
                      key={index}
                      onClick={() => {
                        setIsCadastralSuggestionsVisible(false);
                        handleRetrieve(result.address, result.geometries);
                      }}
                      className="flex flex-col w-full items-start asset-result"
                    >
                      <button className="w-full" type="button">
                        <span>
                          <span
                            className="flex flex-row space-x-2"
                            style={{ textAlign: "start" }}
                          >
                            <img src={greyMapPin} alt="" />
                            <p>{result.address}</p>
                          </span>
                        </span>
                      </button>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
          {/* ButtonSearchMobile */}
          <div className="tablet:hidden block">
            <ButtonSearch
              onClick={() => handleNextStep(state.selectedOption)}
              data={"rounded-xl w-full py-3"}
              disabled={!_.isEmpty(state.selectedOption) ? false : true}
            />
          </div>
          {isAddressWrongFormatError && (
            <p style={{ padding: "1em 0 0 0", margin: 0, color: "red" }}>
              Por favor, comprueba que es una dirección válida.
            </p>
          )}
          {isCadastralRefValidVisible && (
            <p style={{ padding: "1em 0 0 0", margin: 0, color: "red" }}>
              No hemos encontrado viviendas con esa referencia catastral.
            </p>
          )}
        </form>
      ) : (
        <div>Unauthorized access</div>
      )}
    </>
  );
};

export default UDASearch;
